import { render, staticRenderFns } from "./DataTableSkeleton.vue?vue&type=template&id=633157d6&scoped=true"
import script from "./DataTableSkeleton.vue?vue&type=script&lang=js"
export * from "./DataTableSkeleton.vue?vue&type=script&lang=js"
import style0 from "./DataTableSkeleton.vue?vue&type=style&index=0&id=633157d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633157d6",
  null
  
)

export default component.exports